import type { Question, Topic } from "./questionTypes";
import { questions as references } from "./englishQuestions";

export type QuestionSpec = readonly [prompt: string, choices: readonly [string, string, string, string], correctIndex?: number];

export interface FactSource {
  section: string;
  manualPage: string;
  pdfPage: number;
  topic: Topic;
  quote: string;
}

const byId = new Map(references.map((question) => [question.id, question]));

export function family(referenceNumber: number, specs: readonly QuestionSpec[]): Question[] {
  const referenceId = `oma8-en-${String(referenceNumber).padStart(3, "0")}`;
  const reference = byId.get(referenceId);
  if (!reference) throw new Error(`Missing OM-A reference ${referenceId}`);
  return specs.slice(0, 2).map(([prompt, choices, correctIndex = 0], index) => ({
    ...reference,
    id: `oma8-pro-${String(referenceNumber).padStart(3, "0")}-${index + 1}`,
    familyId: `oma8-pro-${String(referenceNumber).padStart(3, "0")}`,
    prompt,
    choices: [...choices] as [string, string, string, string],
    correctIndex,
  }));
}

export function factFamily(key: string, source: FactSource, specs: readonly QuestionSpec[]): Question[] {
  return specs.slice(0, 2).map(([prompt, choices, correctIndex = 0], index) => ({
    id: `oma8-fact-${key}-${index + 1}`,
    familyId: `oma8-fact-${key}`,
    topic: source.topic,
    section: source.section,
    manualPage: source.manualPage,
    pdfPage: source.pdfPage,
    pageWidth: 595.27,
    pageHeight: 841.89,
    prompt,
    choices: [...choices] as [string, string, string, string],
    correctIndex,
    explanation: source.quote,
    sourceQuote: source.quote,
    sourceRects: [],
  }));
}
